import axios from 'axios';

const api = axios.create({
  baseURL: 'https://back.digitrack.metaglobaltech.com',
});

export default api;
